import React, { forwardRef } from "react";

const Video = forwardRef((props, ref) => {
  return (
    <video
      {...props}
      ref={ref}
      className={`w-full shadow-2xl ${props?.className}`}
    ></video>
  );
});

export default Video;
